// extracted by mini-css-extract-plugin
export default {"AppTabs":"AppTabsBase_AppTabs__JlYej"};